{
  "$schema": "../extension_schema.json",
  "name": "labels",
  "enabled": true,
  "contextCharacteristics": [
    {
      "kind": "Capsule",
      "defaultValue": false,
      "proxyKind": "selected",
      "eventTimeRepresentation": "capsule",
      "reducer": "set"
    },
    {
      "kind": "Condition",
      "defaultValue": false,
      "proxyKind": "selected",
      "eventTimeRepresentation": "investigationTime",
      "reducer": "set"
    },
    {
      "kind": "Asset",
      "defaultValue": false,
      "proxyKind": "selected",
      "eventTimeRepresentation": "investigationTime",
      "reducer": "set"
    }
  ],
  "uiConfig": {
    "columns": [
      {
        "aggFunc": "LookupAggregator",
        "colDefDefaultValue": [],
        "colDefMinWidth": 110,
        "colDefName": "Labels",
        "colDefType": "array",
        "colDefFilterType": "set",
        "onClickAction": "toggleState"
      }
    ],
    "iconRepresentation": {
      "isUniqueValueSet": true,
      "defaultRepresentation": false,
      "discreteStates": [
        {
          "labelTranslationKey": "VANTAGE.EXTENSIONS.LABELS.LABEL",
          "value": true,
          "icon": "svgpath:M 18.735 6.684 L 19 6.979 L 19 7.397 L 19 11.598 L 19 12.016 L 18.735 12.312 L 12.75 19 L 11.464 17.564 L 17.184 11.18 L 17.184 7.82 L 11.464 1.436 L 12.75 0 L 18.735 6.684 Z M 0 9.5 L 0 0.042 L 8.475 0.042 L 15.739 8.149 L 15.739 10.851 L 8.475 18.958 L 0 9.5 Z M 5.448 4.771 C 5.448 3.731 4.439 3.081 3.632 3.601 C 3.257 3.842 3.027 4.288 3.027 4.771 C 3.027 5.811 4.036 6.461 4.843 5.941 C 5.217 5.7 5.448 5.254 5.448 4.771 Z",
          "tooltipTemplateTranslationKey": "VANTAGE.EXTENSIONS.LABELS.LABEL_APPLIED"
        },
        {
          "labelTranslationKey": "VANTAGE.EXTENSIONS.LABELS.LABEL",
          "value": false,
          "icon": "svgpath:M 18.735 6.684 L 19 6.979 L 19 7.397 L 19 11.598 L 19 12.016 L 18.735 12.312 L 12.75 19 L 11.464 17.564 L 17.184 11.18 L 17.184 7.82 L 11.464 1.436 L 12.75 0 L 18.735 6.684 Z M 0 9.5 L 0 0.042 L 8.475 0.042 L 15.739 8.149 L 15.739 10.851 L 8.475 18.958 L 0 9.5 Z M 5.448 4.771 C 5.448 3.731 4.439 3.081 3.632 3.601 C 3.257 3.842 3.027 4.288 3.027 4.771 C 3.027 5.811 4.036 6.461 4.843 5.941 C 5.217 5.7 5.448 5.254 5.448 4.771 Z",
          "iconFill": "white",
          "tooltipTemplateTranslationKey": "VANTAGE.EXTENSIONS.LABELS.LABEL_REMOVED"
        }
      ],
      "mixedStates": {
        "labelTranslationKey": "VANTAGE.EXTENSIONS.LABELS.LABEL",
        "icon": "svgpath:M 18.735 6.684 L 19 6.979 L 19 7.397 L 19 11.598 L 19 12.016 L 18.735 12.312 L 12.75 19 L 11.464 17.564 L 17.184 11.18 L 17.184 7.82 L 11.464 1.436 L 12.75 0 L 18.735 6.684 Z M 0 9.5 L 0 0.042 L 8.475 0.042 L 15.739 8.149 L 15.739 10.851 L 8.475 18.958 L 0 9.5 Z M 5.448 4.771 C 5.448 3.731 4.439 3.081 3.632 3.601 C 3.257 3.842 3.027 4.288 3.027 4.771 C 3.027 5.811 4.036 6.461 4.843 5.941 C 5.217 5.7 5.448 5.254 5.448 4.771 Z",
        "value": "*"
      }
    },
    "extensionSpecificConfiguration": {
      "defaultOptions": ["Model Maintenance", "Documented", "Validating"],
      "popularOptions": 5
    },
    "consoleToolbarConfiguration": {
      "sortOrder": 3,
      "onClick": "deferToComponentUI",
      "componentUi": "Labels",
      "portal": "toolbar"
    }
  }
}
